module.exports = __webpack_public_path__ + "static/media/change-manager-for-team.e17e1fcd.svg";